<template>
  <div class="menu" role="menu">
    <slot />
  </div>
</template>

<script lang="ts" setup>
</script>

<style lang="scss" scoped>
.menu {
  @apply py-10;
  @apply flex flex-col;
}
</style>
